import React, { useState, useEffect } from 'react';
import { renameColumns, getInfo } from '../../utils/api';
import { toast } from 'sonner';
import { useT } from '../../i18n';

const RenameColumnsOperation = ({ onSuccess, onCancel }) => {
  const t = useT();
  const [columns, setColumns] = useState([]);
  const [renames, setRenames] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadColumns = async () => {
      try {
        const result = await getInfo();
        const cols = result.info.column_names || [];
        setColumns(cols);
        const initialRenames = {};
        cols.forEach(col => {
          initialRenames[col] = col;
        });
        setRenames(initialRenames);
      } catch (error) {
        toast.error(t('form.loadColumnsFailed'));
      }
    };
    loadColumns();
  }, []);

  const updateRename = (oldName, newName) => {
    setRenames({ ...renames, [oldName]: newName });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const renameMap = {};
    Object.keys(renames).forEach(key => {
      if (renames[key] !== key) {
        renameMap[key] = renames[key];
      }
    });
    
    if (Object.keys(renameMap).length === 0) {
      toast.error(t('rename.none'));
      return;
    }
    
    setLoading(true);
    try {
      const result = await renameColumns(renameMap);
      onSuccess(result);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('rename.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="label mb-2">{t('rename.title')}</label>
        <div className="card p-4 max-h-96 overflow-y-auto space-y-3">
          {columns.map(col => (
            <div key={col} className="grid grid-cols-2 gap-3 items-center">
              <div>
                <p className="text-sm font-medium text-muted-foreground">{col}</p>
              </div>
              <div>
                <input
                  type="text"
                  value={renames[col] || col}
                  onChange={(e) => updateRename(col, e.target.value)}
                  className="input"
                  placeholder={col}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-2 pt-4 border-t">
        <button type="submit" disabled={loading} className="btn-primary flex-1" data-testid="apply-rename">
          {loading ? t('rename.renaming') : t('rename.apply')}
        </button>
        <button type="button" onClick={onCancel} className="btn-secondary">
          {t('form.cancel')}
        </button>
      </div>
    </form>
  );
};

export default RenameColumnsOperation;